import { gsap, Power4 } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { isMobile } from "./uilts";

class Vision {
    
    visionTimeline; // 비전 타임라인.
    visionSectionElem;

    visionWrapperElem;
    visionbgElem;               // 배경 색.
    visionCircleElem;           // 중앙 원.
    visionCircleLogoElem;       // 중앙 원 안의 로고.

    rootImpactLogo;             // 루트임팩트 헤더 로고.
    rootImpactLogoReverse;

    visionMsgList;


    // 원 1
    visionCircle1Elem;              // 원 전체.
    visionCircle1WaveList;          // 물결 웨이브.
    visionInnerCircle1Elem;         // 외곽선 원.
    visionInnerCircle1HalfElem;     // 첫 라인 드로잉 표현용 반 원.
    visionInnerCircle1bgElem;       // 배경색.
    
    // 원 2
    visionCircle2Elem               // 원 전체.
    visionCircle2WaveList;          // 물결 웨이브.
    visionInnerCircle2Elem;         // 외곽선 원.
    visionInnerCircle2HalfElem;     // 첫 라인 드로잉 표현용 반 원.
    visionInnerCircle2bgElem;       // 배경색.

    // 원 3
    visionCircle3Elem;              // 원 전체.
    visionCircle3WaveList;          // 물결 웨이브.
    visionInnerCircle3Elem;         // 외곽선 원.
    visionInnerCircle3bgElem;       // 배경색.

    orbitWrapperList;   // 원 전체 공전 그룹.
    textWrapperList;    // 원 전체 텍스트 그룹.


    // 이미지 줌아웃 구간.
    visionPictureWrapperElem;       // 사진 래퍼 루트.
    visionCenterWaveList;           // 화면 중앙 웨이브 원 리스트.
    visionPicGroupList;                  // 사진 그룹 리스트.
    visionParticleGroupList;        // 배경 파티클 그룹 리스트.
    visionCenterTextList;           // 사진, 중앙 텍스트 리스트.


    // 마지막 구간.
    visionVideoOrbitWrapperElem;    // 공전 원 구간 래퍼 루트.
    visionVideoOrbitList;           // 공전 원 리스트.

    visionVideoOrbitAnim1Elem;
    visionVideoOrbitAnim2Elem;

    visionVideoWrapperElem;          // Vision 비디오 엘리먼트.

    // 셀레브레이트 복구.
    celebrateOrbitWrapper;


    videoPlayWrapperElem;           // 비디오 클릭 영역 표시.
    playbtnElem;                    // 클러스터 영상 팝업 띄우기.
    dimmElem;                       // 비디오 백그라운드 배경.
    videoVisionPopupElem;          // 비디오 팝업.
    isOpenVisionVideo;             // 팝업 오픈 여부.


    // Celebration
    celebrateElem;                  // Celebrate ROOT 엘리먼트.


    //===================================================================
    // 트랜지션 커버 제어용
    //===================================================================
    campusCoverElem;   // 이전 세션 커버.
    visionCoverElem;    // 현재 세션 커버.

    campusCoverItemElem;    // 캠퍼스 커버 - 루트.
    campusCoverFadeWrapper; // 캠퍼스 커버 - 콘텐츠 알파 조정용.
    campusCoverlogoWrapper; // 캠퍼스 커버 - 비전 중앙 로고.


    // GNB
    gnbGlobalNavbar;
    gnbDropdown;

    //Vimeo
    vimeoPlayer;


    totalLengthRate = 4;        // 스크롤 전체 길이 비율. ( 값이 클수록 스크롤 길어짐 = 속도 느려짐. )

    constructor() {
        this.gnbGlobalNavbar = document.querySelector('nav.global-nav');
        this.gnbDropdown = document.querySelector('nav .dropdown-menu');


        this.visionSectionElem = document.querySelector('#vision');
        this.visionWrapperElem = document.querySelector('.vision-wrapper');
        this.visionCircleElem = this.visionWrapperElem.querySelector('.vison-center-circle');
        this.visionbgElem = this.visionWrapperElem.querySelector('.vison-bg');
        this.visionCircleLogoElem = this.visionWrapperElem.querySelector('.vision-logo-wrapper');

        this.rootImpactLogo = document.querySelector('.nav-logo-wrapper .logo');
        this.rootImpactLogoReverse = document.querySelector('.nav-logo-wrapper .logo-reverse');

        this.visionMsgList = gsap.utils.toArray('.global-message-wrapper .message.vision-msg');
        

        this.visionCircle1Elem = this.visionWrapperElem.querySelector('.vision-circle-1');
        this.visionInnerCircle1Elem = this.visionWrapperElem.querySelector('.vision-circle-1 .circle-1');
        this.visionInnerCircle1HalfElem = this.visionWrapperElem.querySelector('.vision-circle-1 .circle-half.half-1');
        this.visionInnerCircle1bgElem = this.visionInnerCircle1Elem.querySelector('.circle-1.bg');
        this.visionCircle1WaveList = gsap.utils.toArray('.wave-wrapper .circle-1.wave-circle-1');
        
        this.visionCircle2Elem = this.visionWrapperElem.querySelector('.vision-circle-2');
        this.visionInnerCircle2Elem = this.visionWrapperElem.querySelector('.vision-circle-2 .circle-2');
        this.visionInnerCircle2HalfElem = this.visionWrapperElem.querySelector('.vision-circle-2 .circle-half.half-2');
        this.visionInnerCircle2bgElem = this.visionInnerCircle2Elem.querySelector('.circle-2.bg');
        this.visionCircle2WaveList = gsap.utils.toArray('.wave-wrapper .circle-2.wave-circle-2');
        
        this.visionCircle3Elem = this.visionWrapperElem.querySelector('.vision-circle-3');
        this.visionInnerCircle3Elem = this.visionWrapperElem.querySelector('.vision-circle-3 .circle-3');
        this.visionInnerCircle3bgElem = this.visionInnerCircle3Elem.querySelector('.circle-3.bg');
        this.visionCircle3WaveList = gsap.utils.toArray('.wave-wrapper .circle-3.wave-circle-3');


        this.visionCircleGroup = this.visionWrapperElem.querySelector('.vision-circle-group');
        this.orbitWrapperList = gsap.utils.toArray('.vision-circle-group .orbit-wrapper');
        this.textWrapperList = gsap.utils.toArray('.vision-circle-group .text-wrapper');

        this.visionPictureWrapperElem =  this.visionWrapperElem.querySelector('.picture-wrapper');
        this.visionCenterWaveList = gsap.utils.toArray('.picture-wrapper .wave-group .wave');
        this.visionPicGroupList = gsap.utils.toArray('.picture-wrapper #pic-group');
        this.visionParticleGroupList = gsap.utils.toArray('.picture-wrapper .particle-bg-group');
        this.visionCenterTextList = gsap.utils.toArray('.picture-wrapper .vision-message-wrapper .message');


        this.visionVideoOrbitWrapperElem = document.querySelector('.vision-orbit-wrapper');
        this.visionVideoOrbitList = gsap.utils.toArray('.vision-orbit-wrapper .orbit');

        this.visionVideoOrbitAnim1Elem = document.querySelector('.orbit .rotate-wrapper-1');
        this.visionVideoOrbitAnim2Elem = document.querySelector('.orbit .rotate-wrapper-2');

        this.visionVideoWrapperElem = document.querySelector('.vision-video-wrapper');

        this.celebrateOrbitWrapper = document.querySelector('.celebrate-orbit-wrapper');


        this.campusCoverElem = document.querySelector('.transiton-cover.campus-page');
        this.campusCoverItemElem = document.querySelector('.transiton-cover.campus-page .item');
        this.campusCoverFadeWrapper = document.querySelector('.transiton-cover.campus-page .fade-wrapper');
        this.campusCoverlogoWrapper = document.querySelector('.transiton-cover.campus-page .vison-center-circle .vision-logo-wrapper');
        this.visionCoverElem = document.querySelector('.transiton-cover.vision-page');

        

        this.videoPlayWrapperElem = this.visionSectionElem.querySelector('#vision-playbtn');
        this.dimmElem = document.querySelector('.container .background-dim');
        this.videoVisionPopupElem = document.querySelector('.container #video-vision');

        this.celebrateElem = document.querySelector('.celebrate');

        this.vimeoPlayer = new Vimeo.Player(document.querySelector('#iframe-vision'));
        
        this.playbtnElem = document.querySelector('#play-vision-video');
        this.playbtnElem.addEventListener('click', () => {
            if(this.isOpenVisionVideo) return;
            this.isOpenVisionVideo = true;
            this.setVideoPopup('flex');
            this.vimeoPlayer.play();
        });

        document.querySelectorAll('#close-video-vision').forEach((elem) => {
            elem.addEventListener('click', () => {
                this.vimeoPlayer.pause();
                this.isOpenVisionVideo = false;
                this.setVideoPopup('none');
            });
        });
    }

    init() {
        this.visionTimeline = gsap.timeline({
            scrollTrigger: {
                trigger: this.visionSectionElem,
                start: "top top",
                end: () => isMobile() ? `+=1600%` : `+=1700% bottom`,
                scrub: 1,
                pin: true,
                // markers: true,
                invalidateOnRefresh: true,
                // anticipatePin: 1,
                id: 'vision',
                preventOverlaps: true,
                fastScrollEnd: true
            }
        });

        this.visionTimeline.to(this.campusCoverFadeWrapper, {opacity: 0, duration: 20});
        this.visionTimeline.to(this.campusCoverlogoWrapper, {opacity: 1, duration: 10},"-=10");
        this.visionTimeline.set('.transiton-cover.campus-page .video-wrapper', {autoAlpha: 0});

        this.visionTimeline.to(this.campusCoverItemElem, {
            "clip-path": "circle(8% at center)",
            duration: 50
        },"-=20");

        // 루트임팩트 로고 색상 반전.
        // if(!isMobile()) {
            this.visionTimeline.fromTo(this.rootImpactLogoReverse, { opacity: 0 }, { opacity: 1, duration: 1 },"-=25");
            this.visionTimeline.fromTo(this.rootImpactLogo, { opacity: 1 }, { opacity: 0, duration: 1,
                onComplete: () => this.updateGNB('dark'),
                onReverseComplete: () => this.updateGNB('light') 
            },"-=1");
        // }


        // this.visionTimeline.fromTo(this.campusCoverElem,{opacity: 1}, {opacity: 0});
        // this.visionTimeline.set(this.campusCoverElem, {css: {display: 'none'}});

        // 텍스트 표시 - (루트 임팩트는)
        this.visionTimeline.fromTo(this.visionMsgList[0], { y: 30, opacity: 0 }, { y: 0, opacity: 1, duration: 1});


        // 제거예정. 비전 세션 내부의 클립패스.
        // this.visionTimeline.to(this.visionCircleLogoElem, {opacity: 1, duration: 2 },"-=1");
        // this.visionTimeline.to(this.visionCircleElem, {
        //     "clip-path": "circle(8% at center)",
        //     duration: 4
        // }, "-=2" );

        // 원형 라인 교차. ( 커튼 제거 ) 80d = 900
        this.visionTimeline.to(this.visionInnerCircle1HalfElem, {scaleX: 1, scaleY: 0, transformOrigin: 'center top', duration: 80},"+=80");
        this.visionTimeline.to(this.visionInnerCircle2HalfElem, {scaleX: 1, scaleY: 0, transformOrigin: 'center bottom', duration: 80},"-=80");
        
        // 이전 텍스트 숨김 및 새로운 텍스트 표시 - (임팩트 지향조직과...)
        // this.visionTimeline.fromTo(this.visionMsgList[0], { opacity: 1 }, { opacity: 0, duration: 5},"-=5");
        this.visionTimeline.set(this.visionMsgList[0], { opacity: 0 });
        this.visionTimeline.fromTo(this.visionMsgList[1], { y: 30, opacity: 0 }, { y: 0, opacity: 1, duration: 5});


        // 교차 애니메이션용 반원 숨기기 / 전체 원 표시.
        // this.visionTimeline.to(this.visionInnerCircle1HalfElem, { autoAlpha: 0, duration: 0.5}, "-=0.5");
        // this.visionTimeline.to(this.visionInnerCircle2HalfElem, { autoAlpha: 0, duration: 0.5}, "-=0.5");


        //=======================================================================================================================
        // Mobile.
        //=======================================================================================================================
        if(isMobile()) {

            // 줌 아웃.
            // this.visionTimeline.to(this.visionCircleElem, { opacity: 0, duration: 3 }, "+=10");
            this.visionTimeline.to(this.campusCoverElem, { autoAlpha: 0, duration: 30 }, "+=20");
            // 이전 텍스트 숨김
            this.visionTimeline.fromTo(this.visionMsgList[1], { opacity: 1 }, { opacity: 0, duration: 5}, "-=10");

            this.visionTimeline.fromTo(this.visionCircle1Elem, 
                { 
                    x: () => -(this.visionInnerCircle1Elem.offsetWidth / 2),
                    y: () => 0,
                    xPercent: 0,
                    yPercent: 0,
                    width: '150vmin',
                    height: '150vmin', 
                    transformOrigin: 'center center'
                }, 
                { 
                    x: () => -(this.visionInnerCircle1Elem.offsetWidth / 8) - 8,
                    y: () => 0,
                    xPercent: 0,
                    yPercent: 0,
                    width: '50vmin', 
                    height: '50vmin', 
                    transformOrigin: 'center center',
                    duration: 40 
                }, "-=10");

            this.visionTimeline.fromTo(this.visionCircle2Elem, 
                { 
                    x: () => (this.visionInnerCircle2Elem.offsetWidth / 2),
                    y: () => 0,
                    xPercent: -50,
                    yPercent: -50,
                    width: '150vmin',
                    height: '150vmin', 
                    transformOrigin: 'center center'
                }, 
                { 
                    x: () => (this.visionInnerCircle2Elem.offsetWidth / 8) + 8,
                    y: () => 0,
                    xPercent: -50,
                    yPercent: -50,
                    width: '50vmin', 
                    height: '50vmin', 
                    transformOrigin: 'center center',
                    duration: 40
                }, "-=40");


            // 내부 원 (가로세로 크기 줄임 = 스케일 효과)
            this.visionTimeline.fromTo(this.visionInnerCircle1Elem, { width: '150vmin', height: '150vmin', transformOrigin: 'center center' }, { width: '50vmin', height: '50vmin', transformOrigin: 'center center', duration: 40 }, "-=40");
            this.visionTimeline.fromTo(this.visionInnerCircle2Elem, { width: '150vmin', height: '150vmin', transformOrigin: 'center center' }, { width: '50vmin', height: '50vmin', transformOrigin: 'center center', duration: 40 }, "-=40");
    
            // 내부 원 백그라운드 색상 커버
            this.visionTimeline.fromTo(this.visionInnerCircle1bgElem, { width: '150vmin', height: '150vmin', transformOrigin: 'center center' }, { width: '50vmin', height: '50vmin', transformOrigin: 'center center', duration: 40 }, "-=40");
            this.visionTimeline.fromTo(this.visionInnerCircle2bgElem, { width: '150vmin', height: '150vmin', transformOrigin: 'center center' }, { width: '50vmin', height: '50vmin', transformOrigin: 'center center', duration: 40 }, "-=40");
                       

            // 원 텍스트 및 공전 원 표시.
            this.orbitWrapperList.forEach((elem, index) => {
                this.visionTimeline.to(elem, { opacity: 1, duration: 3 }, "-=3");
            });
            this.textWrapperList.forEach((elem, index) => {
                this.visionTimeline.to(elem, { opacity: 1, duration: 3 }, "-=3");
            });

            // 원 주변 공전 애니메이션.
            const orbitTimeline = gsap.timeline({ repeat: -1});
            this.orbitWrapperList.forEach((elem, index) => {
                orbitTimeline.fromTo(elem, {rotation: 0}, {rotation: 360, transformOrigin: 'right bottom', duration: 240}, "-=240");
            });

            // 새로운 텍스트 표시 - (이들이 함께모여...)
            this.visionTimeline.fromTo(this.visionMsgList[2], { y: 30, opacity: 0 }, { y: 0, opacity: 1, duration: 5 });

            // 3번째 원 추가.
            this.visionTimeline.fromTo(this.visionCircle3Elem, 
                { 
                    x: 0, 
                    y: () => window.innerHeight * 1.2,
                    xPercent: -50,
                    yPercent: -50,
                },
                {   
                    x: 0,
                    y: () => this.visionInnerCircle3Elem.offsetWidth - (this.visionInnerCircle3Elem.offsetWidth / 4),
                    xPercent: -50,
                    yPercent: -50,
                    duration: 50,
                }, "+=70");


            // 이전 텍스트 숨김 및 새로운 텍스트 표시 - (루트임팩트는 앞으로...)
            // this.visionTimeline.fromTo(this.visionMsgList[2], { opacity: 1 }, { opacity: 0, duration: 5 }, "-=5");
            this.visionTimeline.set(this.visionMsgList[2], { opacity: 0 });
            this.visionTimeline.fromTo(this.visionMsgList[3], { y: 30, opacity: 0 }, { y: 0, opacity: 1, duration: 5 });

            // 배경색 페이드인.
            this.visionTimeline.to(this.visionInnerCircle1bgElem, { opacity: 0.85, duration: 5 }, "+=90");
            this.visionTimeline.to(this.visionInnerCircle2bgElem, { opacity: 0.85, duration: 5 }, "-=5");
            this.visionTimeline.to(this.visionInnerCircle3bgElem, { opacity: 0.85, duration: 5, onComplete: ()=> orbitTimeline.pause(), onReverseComplete: ()=> orbitTimeline.play() }, "-=5");

            this.visionTimeline.set(this.visionInnerCircle1Elem, {css: {'border': '1px solid transparent'}});
            this.visionTimeline.set(this.visionInnerCircle2Elem, {css: {'border': '1px solid transparent'}});
            this.visionTimeline.set(this.visionInnerCircle3Elem, {css: {'border': '1px solid transparent'}});

            this.orbitWrapperList.forEach((elem, index) => {
                this.visionTimeline.to(elem, { opacity: 0, duration: 5 }, index === 0 ? "+=0" : "-=5");
                // this.visionTimeline.to(elem, {css: {display: 'none'}});
            });

            // 이전 텍스트 숨김 및 새로운 텍스트 표시 - (임팩트 생태계의 연결자로...)
            // this.visionTimeline.fromTo(this.visionMsgList[3], { opacity: 1 }, { opacity: 0, duration: 5 }, "-=5");
            this.visionTimeline.set(this.visionMsgList[3], { opacity: 0 });
            this.visionTimeline.fromTo(this.visionMsgList[4], { y: 30, opacity: 0 }, { y: 0, opacity: 1, duration: 5 });



            // 웨이브 재생.
            // 1번 원 웨이브.
            const wave1TL = gsap.timeline();
            this.visionCircle1WaveList.forEach((elem) => wave1TL.set(elem, { width: '50vmin', height: '50vmin', opacity: 1 }));
            this.visionCircle1WaveList.forEach((elem, index) => {
                // wave1TL.set(elem, { width: '50vmin', height: '50vmin', opacity: 1 });
                wave1TL.fromTo(elem, { scale: 1 }, { scale: 1.5, opacity: 0, duration: 60 }, index === 0 ? "-=0" : "-=35");  // 기본 플레이 구간 10 + ( 10에서 -4 당김 = 6 ) = 16
                // wave1TL.to(elem, { opacity: 0, duration: 10 }, "-=10");
            });
            this.visionTimeline.add(wave1TL);

            // 2번 원 웨이브.
            const wave2TL = gsap.timeline();
            this.visionCircle2WaveList.forEach((elem) => wave2TL.set(elem, { width: '50vmin', height: '50vmin', opacity: 1 }));
            this.visionCircle2WaveList.forEach((elem, index) => {
                // wave2TL.set(elem, { width: '50vmin', height: '50vmin', opacity: 1 });
                wave2TL.fromTo(elem, { scale: 1 }, { scale: 1.5, opacity: 0, duration: 60 }, index === 0 ? "-=0" : "-=35");
                // wave2TL.to(elem, { opacity: 0, duration: 10 }, "-=10");
            });
            this.visionTimeline.add(wave2TL, "-=110");

            // 3번 원 웨이브.
            const wave3TL = gsap.timeline();
            this.visionCircle3WaveList.forEach((elem) => wave3TL.set(elem, { width: '50vmin', height: '50vmin', opacity: 1 }));
            this.visionCircle3WaveList.forEach((elem, index) => {
                // wave3TL.set(elem, { width: '50vmin', height: '50vmin', opacity: 1 });
                wave3TL.fromTo(elem, { scale: 1 }, { scale: 1.5, opacity: 0, duration: 60 }, index === 0 ? "-=0" : "-=35");
                // wave3TL.to(elem, { opacity: 0, duration: 10 }, "-=10");
            });
            this.visionTimeline.add(wave3TL, "-=110");


            // 원 센터 결합.
            this.visionTimeline.to(this.visionCircle1Elem, { x: 0, y: 0, xPercent: 0, yPercent: 0, scale: 0.05, duration: 30 });
            this.visionTimeline.to(this.visionCircle2Elem, { x: 0, y: 0, xPercent: -50, yPercent: -50, scale: 0.05, duration: 30 }, "-=30");
            this.visionTimeline.to(this.visionCircle3Elem, { x: 0, y: 0, xPercent: -50, yPercent: -50, scale: 0.05, duration: 30 }, "-=30");
            // 텍스트 페이드 아웃.
            this.textWrapperList.forEach((elem, index) => {
                this.visionTimeline.to(elem, { opacity: 0, duration: 5 }, "-=5");
            });

            this.visionTimeline.set(this.visionCircle1Elem, { opacity: 0 });  // 1,3 원 숨김.
            this.visionTimeline.set(this.visionCircle3Elem, { opacity: 0 });
            this.visionTimeline.set(this.visionInnerCircle2bgElem, { css: { 'background-color': '#00A75D' } }); // 2번 원 색상 변경 후...
            this.visionTimeline.to(this.visionInnerCircle2bgElem, { opacity: 1, duration: 5 }, "-=5");

            // 이전 텍스트(제목) 제거.
            this.visionTimeline.set(this.visionMsgList[4], { opacity: 0 });

            // 나머지 스케일 축소 진행.
            this.visionTimeline.to(this.visionCircle2Elem, { scale: 0, duration: 30 });




            // 다음 씬 진행....
            // 웨이브 재생
            this.visionCenterWaveList.forEach((elem, index) => {
                this.visionTimeline.fromTo(elem, 
                    { x:0, y:0, xPercent:-50, yPercent:-50 }, 
                    { x:0, y:0, xPercent:-50, yPercent:-50, scale: 1.5, opacity: 0, duration: 30, ease: Power4.easeOut }, 
                    index === 0 ? '+=0' : `-=${20 - (8 * index)}`);
            }); // 20 + 8 + 4 = 32


            // 타이틀 / 사진 / 배경 표시.
            // 이전 텍스트 숨김 및 새로운 텍스트 표시 - (...창업가도,)
            this.visionTimeline.fromTo(this.visionCenterTextList[0], { y: 30, opacity: 0 }, { y: 0, opacity: 1, duration: 5 }, "-=20");
            // 1번 그룹 사진 정위치.
            this.visionTimeline.fromTo(this.visionPicGroupList[0], { scale: 1.5, opacity: 0 }, { scale: 1, opacity: 1, duration: 30 }, "-=30");

            // 이전 텍스트 숨김 및 새로운 텍스트 표시 - (...청년도,)
            this.visionTimeline.fromTo(this.visionCenterTextList[0], { opacity: 1 }, { opacity: 0, duration: 10 }, "+=60");
            this.visionTimeline.fromTo(this.visionCenterTextList[1], { y: 30, opacity: 0 }, { y: 0, opacity: 1, duration: 10 }, "-=10");

            // 2번 그룹 사진 정위치. 나머지 축소 및 숨김.
            this.visionTimeline.to(this.visionPicGroupList[0], { scale: 0.5, opacity: 0.4, duration: 30 }, "-=30");
            this.visionTimeline.to(this.visionParticleGroupList[0], { opacity: 0, duration: 30 }, "-=30");
            this.visionTimeline.fromTo(this.visionPicGroupList[1], { scale: 1.5, opacity: 0 }, { scale: 1, opacity: 1, duration: 30 }, "-=30");


            // 이전 텍스트 숨김 및 새로운 텍스트 표시 - (...자선가도,)
            this.visionTimeline.fromTo(this.visionCenterTextList[1], { opacity: 1 }, { opacity: 0, duration: 10 }, "+=60");
            this.visionTimeline.fromTo(this.visionCenterTextList[2], { y: 30, opacity: 0 }, { y: 0, opacity: 1, duration: 10 }, "-=10");

            // 3번 그룹 사진 정위치. 나머지 축소 및 숨김.
            this.visionTimeline.to(this.visionPicGroupList[0], { scale: 0.3, opacity: 0.1, duration: 30 }, "-=30");
            this.visionTimeline.to(this.visionPicGroupList[1], { scale: 0.5, opacity: 0.4, duration: 30 }, "-=30");
            this.visionTimeline.to(this.visionParticleGroupList[1], { opacity: 0, duration: 30 }, "-=30");
            this.visionTimeline.fromTo(this.visionPicGroupList[2], { scale: 1.5, opacity: 0 }, { scale: 1, opacity: 1, duration: 30 }, "-=30");



            



        //=======================================================================================================================
        // Desktop.
        //=======================================================================================================================
        } else {

            // 줌 아웃.
            // this.visionTimeline.to(this.visionCircleElem, { opacity: 0, duration: 3 }, "+=10");
            this.visionTimeline.to(this.campusCoverElem, { autoAlpha: 0, duration: 30 }, "+=20");
            // this.visionTimeline.fromTo(this.visionCircle1Elem, { x: () => -this.visionInnerCircle1Elem.offsetWidth / 2, width: '150vw', height: '150vh' }, { x: () => -(this.visionInnerCircle1Elem.offsetWidth / 8) + (this.visionInnerCircle1Elem.offsetWidth * 0.025), width: '50vw', height: '50vh', duration: 30 }, "-=10");
            // this.visionTimeline.fromTo(this.visionCircle2Elem, { x: () => this.visionInnerCircle2Elem.offsetWidth / 2, width: '150vw', height: '150vh' }, { x: () => (this.visionInnerCircle2Elem.offsetWidth / 8) - (this.visionInnerCircle2Elem.offsetWidth * 0.025), width: '50vw', height: '50vh', duration: 30 }, "-=30");
            
            this.visionTimeline.fromTo(this.visionCircle1Elem, { 
                x: () => -this.visionInnerCircle1Elem.offsetWidth / 2, 
                y: 0,
                xPercent: 0,
                yPercent: 0,
                width: '150vmin', 
                height: '150vmin', 
                transformOrigin: 'center center' 
            }, 
            { 
                x: () => -(this.visionInnerCircle1Elem.offsetWidth / 9), 
                y: 0, 
                xPercent: 0,
                yPercent: 0,
                width: '40vmin', 
                height: '40vmin', 
                transformOrigin: 'center center',
                duration: 40 
            }, "-=10");


            this.visionTimeline.fromTo(this.visionCircle2Elem, { 
                x: () => this.visionInnerCircle2Elem.offsetWidth / 2, 
                y: 0, 
                xPercent: -50,
                yPercent: -50,
                width: '150vmin', 
                height: '150vmin', 
                transformOrigin: 'center center' 
            }, { 
                x: () => (this.visionInnerCircle2Elem.offsetWidth / 9), 
                y: 0, 
                xPercent: -50,
                yPercent: -50,
                width: '40vmin', 
                height: '40vmin', 
                transformOrigin: 'center center', 
                duration: 40 
            }, "-=40");
            
            // 내부 원 (가로세로 크기 줄임 = 스케일 효과)
            this.visionTimeline.fromTo(this.visionInnerCircle1Elem, { width: '150vmin', height: '150vmin', transformOrigin: 'center center' }, { width: '40vmin', height: '40vmin', transformOrigin: 'center center', duration: 40 }, "-=40");
            this.visionTimeline.fromTo(this.visionInnerCircle2Elem, { width: '150vmin', height: '150vmin', transformOrigin: 'center center' }, { width: '40vmin', height: '40vmin', transformOrigin: 'center center', duration: 40 }, "-=40");
            // 내부 원 백그라운드 색상 커버
            this.visionTimeline.fromTo(this.visionInnerCircle1bgElem, { width: '150vmin', height: '150vmin', transformOrigin: 'center center' }, { width: '40vmin', height: '40vmin', transformOrigin: 'center center', duration: 40 }, "-=40");
            this.visionTimeline.fromTo(this.visionInnerCircle2bgElem, { width: '150vmin', height: '150vmin', transformOrigin: 'center center' }, { width: '40vmin', height: '40vmin', transformOrigin: 'center center', duration: 40 }, "-=40");


            // 이전 텍스트 숨김
            this.visionTimeline.fromTo(this.visionMsgList[1], { opacity: 1 }, { opacity: 0, duration: 5}, "-=30");
            
            // 원 텍스트 및 공전 원 표시.
            this.orbitWrapperList.forEach((elem, index) => {
                this.visionTimeline.to(elem, { opacity: 1, duration: 3 }, "-=3");
            });
            this.textWrapperList.forEach((elem, index) => {
                this.visionTimeline.to(elem, { opacity: 1, duration: 3 }, "-=3");
            });


            // 원 주변 공전 애니메이션.
            const orbitTimeline2 = gsap.timeline({repeat: -1});
            this.orbitWrapperList.forEach((elem, index) => {
                orbitTimeline2.fromTo(elem, {rotation: 0}, {rotation: 360, transformOrigin: 'right bottom', duration: 240}, "-=240");
            });

            // 새로운 텍스트 표시 - (이들이 함께모여...)
            this.visionTimeline.fromTo(this.visionMsgList[2], { y: 30, opacity: 0 }, { y: 0, opacity: 1, duration: 5 });


            // 원 재배치 시작.
            this.visionTimeline.to(this.visionCircle1Elem, { 
                x: () => -(this.visionInnerCircle1Elem.offsetWidth * 0.3), 
                y: () => -this.visionInnerCircle1Elem.offsetWidth * 0.4, 
                xPercent: 0,
                yPercent: 0,
                duration: 30 
            }, "+=60");

            this.visionTimeline.to(this.visionCircle2Elem, { 
                x: () => -(this.visionInnerCircle2Elem.offsetWidth * 0.3), 
                y: () => this.visionInnerCircle2Elem.offsetWidth * 0.4, 
                xPercent: -50,
                yPercent: -50,
                duration: 30
            }, "-=30");

            // 3번째 원 추가.
            this.visionTimeline.fromTo(this.visionCircle3Elem, { 
                x: () => window.innerWidth * 1.2,
                y: 0,
                xPercent: -50,
                yPercent: -50,
                transformOrigin: 'center center'
             }, 
             { 
                x: () => (this.visionInnerCircle3Elem.offsetWidth * 0.4), 
                duration: 30,
                xPercent: -50,
                yPercent: -50,
                transformOrigin: 'center center'
            }, "-=30");


            // 이전 텍스트 숨김 및 새로운 텍스트 표시 - (루트임팩트는 앞으로...)
            // this.visionTimeline.fromTo(this.visionMsgList[2], { opacity: 1 }, { opacity: 0, duration: 5 }, "-=5");
            this.visionTimeline.set(this.visionMsgList[2], { autoAlpha: 0 });
            this.visionTimeline.fromTo(this.visionMsgList[3], { y: 30, opacity: 0 }, { y: 0, opacity: 1, duration: 5 });

            // 배경색 페이드인.
            this.visionTimeline.to(this.visionInnerCircle1bgElem, { opacity: 0.85, duration: 30 }, "+=60");
            this.visionTimeline.to(this.visionInnerCircle2bgElem, { opacity: 0.85, duration: 30 }, "-=30");
            this.visionTimeline.to(this.visionInnerCircle3bgElem, { opacity: 0.85, duration: 30, onComplete: ()=> orbitTimeline2.pause(), onReverseComplete: ()=> orbitTimeline2.play() }, "-=30");

            this.visionTimeline.set(this.visionInnerCircle1Elem, {css: {'border': '1px solid transparent'}});
            this.visionTimeline.set(this.visionInnerCircle2Elem, {css: {'border': '1px solid transparent'}});
            this.visionTimeline.set(this.visionInnerCircle3Elem, {css: {'border': '1px solid transparent'}});

            this.orbitWrapperList.forEach((elem, index) => {
                this.visionTimeline.to(elem, { autoAlpha: 0, duration: 5 }, index === 0 ? "+=0 " : "-=5");
            });

            // 이전 텍스트 숨김 및 새로운 텍스트 표시 - (임팩트 생태계의 연결자로...)
            // this.visionTimeline.fromTo(this.visionMsgList[3], { opacity: 1 }, { opacity: 0, duration: 5 }, "-=5");
            this.visionTimeline.set(this.visionMsgList[3], { autoAlpha: 0 });
            this.visionTimeline.fromTo(this.visionMsgList[4], { y: 30, opacity: 0 }, { y: 0, opacity: 1, duration: 5 });



            // 웨이브 재생.
            // 1번 원 웨이브.
            const wave1TL = gsap.timeline();
            this.visionCircle1WaveList.forEach((elem) => wave1TL.set(elem, { width: '40vmin', height: '40vmin', opacity: 1 }));
            this.visionCircle1WaveList.forEach((elem, index) => {
                // wave1TL.set(elem, { width: '40vmin', height: '40vmin', opacity: 1 });
                wave1TL.fromTo(elem, { scale: 1 }, { scale: 1.6, duration: 30, ease: Power4.easeOut }, index === 0 ? "+=0" : "-=15");  // 기본 플레이 구간 10 + ( 10에서 -4 당김 = 6 ) = 16
                wave1TL.to(elem, { opacity: 0, duration: 10 }, "-=10");
            });
            this.visionTimeline.add(wave1TL);

            // 2번 원 웨이브.
            const wave2TL = gsap.timeline();
            this.visionCircle2WaveList.forEach((elem) => wave2TL.set(elem, { width: '40vmin', height: '40vmin', opacity: 1 }));
            this.visionCircle2WaveList.forEach((elem, index) => {
                // wave2TL.set(elem, { width: '40vmin', height: '40vmin', opacity: 1 });
                wave2TL.fromTo(elem, { scale: 1 }, { scale: 1.6, duration: 30, ease: Power4.easeOut }, index === 0 ? "-=0" : "-=15");
                wave2TL.to(elem, { opacity: 0, duration: 10 }, "-=10");
            });
            this.visionTimeline.add(wave2TL, "-=60");

            // 3번 원 웨이브.
            const wave3TL = gsap.timeline();
            this.visionCircle3WaveList.forEach((elem) => wave3TL.set(elem, { width: '40vmin', height: '40vmin', opacity: 1 }));
            this.visionCircle3WaveList.forEach((elem, index) => {
                // wave3TL.set(elem, { width: '40vmin', height: '40vmin', opacity: 1 });
                wave3TL.fromTo(elem, { scale: 1 }, { scale: 1.6, duration: 30, ease: Power4.easeOut }, index === 0 ? "-=0" : "-=15");
                wave3TL.to(elem, { opacity: 0, duration: 10 }, "-=10");
            });
            this.visionTimeline.add(wave3TL, "-=60");


            // 원 센터 결합.
            this.visionTimeline.to(this.visionCircle1Elem, { x: 0, y: 0, xPercent: 0, yPercent: 0, transformOrigin: 'center center', scale: 0.05, duration: 30 });
            this.visionTimeline.to(this.visionCircle2Elem, { x: 0, y: 0, xPercent: -50, yPercent: -50, transformOrigin: 'center center', scale: 0.05, duration: 30 }, "-=30");
            this.visionTimeline.to(this.visionCircle3Elem, { x: 0, y: 0, xPercent: -50, yPercent: -50, transformOrigin: 'center center', scale: 0.05, duration: 30 }, "-=30");
            // 텍스트 페이드 아웃.
            this.textWrapperList.forEach((elem, index) => {
                this.visionTimeline.to(elem, { autoAlpha: 0, duration: 5 }, "-=5");
            });

            this.visionTimeline.set(this.visionCircle1Elem, { autoAlpha: 0 });  // 1,3 원 숨김.
            this.visionTimeline.set(this.visionCircle3Elem, { autoAlpha: 0 });
            this.visionTimeline.set(this.visionInnerCircle2bgElem, { css: { 'background-color': '#00A75D' } }); // 2번 원 색상 변경 후...
            this.visionTimeline.to(this.visionInnerCircle2bgElem, { opacity: 1, duration: 5 }, "-=5");

            // 이전 텍스트(제목) 제거.
            this.visionTimeline.set(this.visionMsgList[4], { opacity: 0 });
            // this.visionTimeline.fromTo(this.visionMsgList[4], { opacity: 1 }, { opacity: 0, duration: 5 }, "-=5");

            // 나머지 스케일 축소 진행.
            this.visionTimeline.to(this.visionCircle2Elem, { scale: 0, duration: 25 });


            // 다음 씬 진행....
            // 웨이브 재생
            this.visionCenterWaveList.forEach((elem, index) => {
                this.visionTimeline.fromTo(elem, 
                    { x: 0, y: 0, xPercent: -50, yPercent: -50 },
                    { x: 0, y: 0, xPercent: -50, yPercent: -50, scale: 1.5, autoAlpha: 0, duration: 30, ease: Power4.easeOut }, index === 0 ? '+=0' : `-=${20 - (8 * index)}`);
            }); // 30 + 8 + 4 = 42


            // 타이틀 / 사진 / 배경 표시.
            // 이전 텍스트 숨김 및 새로운 텍스트 표시 - (...창업가도,)
            this.visionTimeline.fromTo(this.visionCenterTextList[0], { y: 30, opacity: 0 }, { y: 0, opacity: 1, duration: 5 },"-=20");
            // 1번 그룹 사진 정위치.
            this.visionTimeline.fromTo(this.visionPicGroupList[0], { scale: 1.5, opacity: 0 }, { scale: 1, opacity: 1, duration: 30 }, "-=30");

            // 이전 텍스트 숨김 및 새로운 텍스트 표시 - (...청년도,)
            this.visionTimeline.fromTo(this.visionCenterTextList[0], { opacity: 1 }, { opacity: 0, duration: 10 }, "+=40");
            this.visionTimeline.fromTo(this.visionCenterTextList[1], { y: 30, opacity: 0 }, { y: 0, opacity: 1, duration: 10 }, "-=10");

            // 2번 그룹 사진 정위치. 나머지 축소 및 숨김.
            this.visionTimeline.to(this.visionPicGroupList[0], { scale: 0.75, opacity: 0.4, duration: 30 }, "-=30");
            this.visionTimeline.to(this.visionParticleGroupList[0], { opacity: 0, duration: 30 }, "-=30");
            this.visionTimeline.fromTo(this.visionPicGroupList[1], { scale: 1.5, opacity: 0 }, { scale: 1, opacity: 1, duration: 30 }, "-=30");



            // 이전 텍스트 숨김 및 새로운 텍스트 표시 - (...자선가도,)
            this.visionTimeline.fromTo(this.visionCenterTextList[1], { opacity: 1 }, { opacity: 0, duration: 10 }, "+=40");
            this.visionTimeline.fromTo(this.visionCenterTextList[2], { y: 30, opacity: 0 }, { y: 0, opacity: 1, duration: 10 }, "-=10");

            // 3번 그룹 사진 정위치. 나머지 축소 및 숨김.
            this.visionTimeline.to(this.visionPicGroupList[0], { scale: 0.4, opacity: 0.1, duration: 30 }, "-=30");
            this.visionTimeline.to(this.visionPicGroupList[1], { scale: 0.75, opacity: 0.4, duration: 30 }, "-=30");
            this.visionTimeline.to(this.visionParticleGroupList[1], { opacity: 0, duration: 30 }, "-=30");
            this.visionTimeline.fromTo(this.visionPicGroupList[2], { scale: 1.5, opacity: 0 }, { scale: 1, opacity: 1, duration: 30 }, "-=30");



        }


        // 마지막 구간 엘리먼트 활성화 후..
        // this.visionTimeline.set(this.visionVideoOrbitWrapperElem, { opacity: 1 });
        this.visionTimeline.to(this.visionVideoOrbitWrapperElem, { autoAlpha: 1, duration: 1 });
        

        // 공전 애니메이션..
        // const orbitVideoTimeline = gsap.timeline({repeat: -1, pause: true});
        // this.visionVideoOrbitList.forEach((elem, index) => {
        //     orbitVideoTimeline.fromTo(elem, { rotation: 0 }, { rotation: 360, duration: 1500 }, "-=1500");
        // });
        
        // 화면 전환...
        this.visionTimeline.fromTo(this.visionPictureWrapperElem, { scale: 1 }, { scale: 0.5, duration: 40 }, isMobile() ? "+=40" : "+=20");
        this.visionTimeline.fromTo(this.visionWrapperElem, 
            { "clip-path": "circle(100% at center)" }, 
            { 
                "clip-path": "circle(0% at center)", 
                duration: isMobile() ? 70 : 30,
                // onComplete: ()=> orbitVideoTimeline.play()
            },
            isMobile() ? "-=38" : "-=38");

        // 루트임팩트 로고 색상 반전.
        // if(!isMobile()) {
            this.visionTimeline.fromTo(this.rootImpactLogo, {opacity: 0 }, {opacity: 1, duration: 1 },"-=30");
            this.visionTimeline.fromTo(this.rootImpactLogoReverse, {opacity: 1 }, {opacity: 0, duration: 1,
                onComplete: () => this.updateGNB('light'),
                onReverseComplete: () => this.updateGNB('dark') 
            },"-=30");
        // }   

        this.visionTimeline.to(this.visionWrapperElem, {css: {display: 'none'}, onComplete: () => this.animateRotation(true), onReverseComplete: () => this.animateRotation(false)});


        // this.visionTimeline.set(this.visionWrapperElem,{css: {display: 'none'}});
        
        // Celebrate 세션 준비.
        // this.visionTimeline.set(this.celebrateElem, { opacity: 1 });
        this.visionTimeline.set(this.visionVideoOrbitWrapperElem, { css: {'z-index': 1} });

        // 공전 원 화면 위로 이동 / 비디오 타이틀 위로 이동.
        this.visionTimeline.to(this.visionVideoOrbitWrapperElem, { y: () => `-=${window.innerHeight * 2}`, duration: isMobile() ? 120 : 60 }, isMobile() ? "+=60" :"+=20"); // 궤도 원의 사이즈 화면보다 큼.
        // this.visionTimeline.fromTo(this.celebrateElem, { y: () => window.innerHeight }, { y: 0, duration: 40 }, "-=40");
        this.visionTimeline.fromTo(this.visionVideoWrapperElem, { y: () => window.innerHeight }, { y: 0, duration: isMobile() ? 120 : 60 },  isMobile() ? "-=120" : "-=60");
        this.visionTimeline.to(this.visionVideoOrbitWrapperElem, { autoAlpha: 0,  duration: 10, onComplete: () => this.animateRotation(false), onReverseComplete: () => this.animateRotation(true) }, "-=20");

        // Scroll To Next 버튼 애니메이션.
        if(document.querySelector('.scroll-down-wrapper.vision .scroll-contents').childElementCount === 0) {
            bodymovin.loadAnimation({
                container: document.querySelector('.scroll-down-wrapper.vision .scroll-contents'),
                renderer: "svg",
                loop: true,
                autoplay: true,
                path: './assets/lottie/PC_ScrollToNext_Light.json'
            });
        }

        // 비디오 재생 버튼 표시.
        this.visionTimeline.fromTo(this.videoPlayWrapperElem, { opacity: 0 }, { opacity: 1, duration: 10 }, "+=10");
        
        // 완료후 트랜지션 커버 활성화.
        this.visionTimeline.set(this.visionCoverElem, {css: {display: 'block'}});
        this.visionTimeline.to({}, { duration: 1}, "+=10");
        // 스크롤 여분 (스크롤시 팝업 열림여부 체크.)
        this.visionTimeline.to(this.videoPlayWrapperElem, { duration: 20 });

        // 비디오 세션 올리기. == Celbration 시작.
        // this.visionTimeline.to(this.visionVideoWrapperElem, { yPercent: -100, duration: 20 }, "+=10");
        // // this.visionTimeline.set(this.visionVideoWrapperElem, {css: {display: 'none'}});
    
        // 화면넘어오는 셀레브레이트 공전 원 복구.
        // this.visionTimeline.fromTo(this.celebrateOrbitWrapper, {opacity: 0} , {opacity: 1, duration: 10}, "-=10");

        return Promise.resolve()
    }

    kill() {
        if(this.visionTimeline) {
            this.visionTimeline.eventCallback("onEnter", null);
            this.visionTimeline.eventCallback("onEnterBack", null);
            this.visionTimeline.eventCallback("onLeave", null);

            // this.visionTimeline.getChildren().forEach(child => {
            //     // gsap.set(child, {clearProps: "all"});
            //     child.kill();
            // });

            this.visionTimeline.clear().kill();
            this.visionTimeline = null;
        }
    }

    // window resize 이벤트 호출시 동작.
    refresh() {
        this.visionTimeline.invalidate();
    }

    /**
     * 비디오 팝업 제어.
     * @param {'flex' | 'none'} state : 팝업 열림 / 닫힘.
     */
    setVideoPopup(state) {
        this.isOpenVisionVideo = (state === 'flex');
        document.querySelector('body').style.overflow = this.isOpenVisionVideo ? 'hidden' : 'visible';
        this.dimmElem.style.display = state;
        this.videoVisionPopupElem.style.display = state;
    }

    animateRotation(running) {
        if (running) {
            if (this.visionVideoOrbitAnim1Elem.classList.contains('stop-animate')) this.visionVideoOrbitAnim1Elem.classList.remove('stop-animate');
            if (this.visionVideoOrbitAnim2Elem.classList.contains('stop-animate')) this.visionVideoOrbitAnim2Elem.classList.remove('stop-animate');
        } else {
            if (!this.visionVideoOrbitAnim1Elem.classList.contains('stop-animate')) this.visionVideoOrbitAnim1Elem.classList.add('stop-animate');
            if (!this.visionVideoOrbitAnim2Elem.classList.contains('stop-animate')) this.visionVideoOrbitAnim2Elem.classList.add('stop-animate');
        }
    }

    // 타임라인
    appendTimeline(timeline, params) {

        if(params) {
            this.visionTimeline.add(timeline, params);
        } else {  
            this.visionTimeline.add(timeline);
        }
    }

    // 타임라인.
    getTimeline() {
        return this.visionTimeline;
    }
    getScrollTrigger() {
        return this.visionTimeline.scrollTrigger;
    }

    /**
     * GNB 색상 갱신.
     * @param {'light' | 'dark'} type 타입.
     */
     updateGNB(type) {
        if(!isMobile()) return;
        if(type === 'dark') {
            if(!this.gnbGlobalNavbar.classList.contains('dark')) this.gnbGlobalNavbar.classList.add('dark');
            if(!this.gnbDropdown.classList.contains('dark')) this.gnbDropdown.classList.add('dark');
            document.querySelector('.svg-navbtn-content g circle').setAttribute('fill','#001B24');
        } else {
            this.gnbGlobalNavbar.classList.remove('dark');
            this.gnbDropdown.classList.remove('dark');
            document.querySelector('.svg-navbtn-content g circle').setAttribute('fill','white');
        }
    }

    lottieScrollTrigger(vars) {
        const targetElem = document.querySelector(`${vars.target}`);
        if(targetElem.hasChildNodes()) {
            targetElem.innerHTML = '';
        }
        let playhead = { frame: 0 },
            target = targetElem,
            st = {
                trigger: vars.trigger ? document.querySelector(vars.trigger) : target,
                scrub: 1,
                // markers: true,
                // invalidateOnRefresh: true,
                onEnter: () => {
                    targetElem.style.display = "block";
                },
            },
            animation = bodymovin.loadAnimation({
                container: target,
                renderer: "svg",
                loop: false,
                autoplay: false,
                path: vars.path,
                initialSegment: vars.segment, // [0, 70] // totalFrames == 180
                rendererSettings: {
                    preserveAspectRatio: vars.preserveAspectRatio ?? 'xMidYMid meet'
                }
            });
        // console.log(180 / (targetElem.offsetWidth / window.innerWidth) );

        for (let p in vars) { // let users override the ScrollTrigger defaults
            st[p] = vars[p];
        }

        animation.addEventListener("DOMLoaded", function () {
            if (vars.timeline) {
                vars.timeline.to(playhead, {
                    frame: animation.totalFrames - 1,
                    ease: "none",
                    onUpdate: () => {
                        // console.log(`${vars.target} - ${playhead.frame}`);
                        animation.goToAndStop(playhead.frame, true)
                    },
                    onComplete: () => {
                        // targetElem.style.display = "none";
                    },
                    scrollTrigger: st
                });
            } else {
                gsap.to(playhead, {
                    frame: animation.totalFrames - 1,
                    ease: "none",
                    onUpdate: () => {
                        // console.log(`${vars.target} - ${playhead.frame}`);
                        animation.goToAndStop(playhead.frame, true)
                    },
                    onComplete: () => {
                        // targetElem.style.display = "none";
                    },
                    scrollTrigger: st
                });
            }
        });

        return animation;
    }

}

export default Vision;